import { VendorMessagesCount } from '../store/models/Stats';

export const calcPublishedMessages = (vendorMessagesCount: VendorMessagesCount[]) => {
  return (
    vendorMessagesCount?.reduce((sum, item) => {
      const value1 = Number(item?.messageCountDBirth);
      const value2 = Number(item?.messageCountDData);

      if (!Number.isNaN(value1) && !Number.isNaN(value2)) {
        return sum + value1 + value2;
      }

      return sum;
    }, 0) ?? 0
  );
};
